export default __webpack_public_path__ + "static/media/hero.7767afb8.svg";